const initialState = {
  lang: localStorage.getItem("lang") ? localStorage.getItem("lang") : "ru"
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_LANGUAGE":
      localStorage.setItem("lang", action.payload);
      return {
        ...state,
        lang: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
